import * as React from 'react';

const GTM_ID = process.env.GATSBY_GOOGLE_TAG_MANAGER_ID;

export const IS_GTM_ENABLED = Boolean(GTM_ID);

export default function GoogleTagManagerHeadScript() {
    if (!GTM_ID) {
        return null;
    }

    return (
        <script
            key="gtm-head"
            dangerouslySetInnerHTML={{
                __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${GTM_ID}');`,
            }}
        />
    );
}
